export default "__VITE_ASSET__Dp6c7YJN__"